import templateUrl from 'webutils/labeled-value.htm'

const LabeledValueComponent = {
  bindings: {
    label: '@',
    value: '@',
    labelClass: '@',
    valueClass: '@'
  },
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};

export default LabeledValueComponent;